if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // The theme renders a hidden cart notification as well as the real drawer.
      // Always prefer the drawer so the first add renders and opens the UI the
      // customer can actually see.
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    getSubscriptionAddonId() {
      const subscriptionAddonInput = this.form.querySelector('[data-subscription-addon-id]');
      if (!subscriptionAddonInput) return '';
      return (subscriptionAddonInput.value || '').trim();
    }

    addSubscriptionAddon() {
      const subscriptionAddonId = this.getSubscriptionAddonId();
      if (!subscriptionAddonId) return Promise.resolve(null);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const addonQuantity = quantityInput && quantityInput.value ? quantityInput.value : '1';
      formData.append('id', subscriptionAddonId);
      formData.append('quantity', addonQuantity);

      const planLabelInput = this.form.querySelector('[data-subscription-plan-label]');
      const planPriceInput = this.form.querySelector('[data-subscription-plan-price]');
      const productTitleInput = this.form.querySelector('[data-subscription-main-product-title]');

      if (planLabelInput && planLabelInput.value) {
        formData.append('properties[_Subscription plan]', planLabelInput.value);
      }

      if (planPriceInput && planPriceInput.value) {
        formData.append('properties[_Subscription price]', planPriceInput.value);
      }

      if (productTitleInput && productTitleInput.value) {
        formData.append('properties[_Linked product]', productTitleInput.value);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      return fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description || 'The subscription plan could not be added to cart.');
            this.error = true;
            return null;
          }

          return response;
        });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return null;
          }

          return this.addSubscriptionAddon().then((addonResponse) => {
            const renderResponse = addonResponse || response;

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return renderResponse;
            }

            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(renderResponse) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(renderResponse);
            }

            return renderResponse;
          });
        })
        .then((response) => {
          if (!response) {
            return;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
